import { Modal, Button, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const empty = {
  bankName: '', countryCode: '', bankBic: '',
  authUrl: '',  refreshUrl: '',  apiKey: '', apiSecret: ''
};

const BankAuthModal = ({ show, onHide, onSave, initial }) => {
  const [form, setForm] = useState(empty);
  useEffect(() => setForm(initial ? { ...initial, apiSecret: '' } : empty), [initial]);

  const c = (f, v) => setForm({ ...form, [f]: v });

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{initial ? 'Edit bank auth' : 'New bank auth'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {['bankName','countryCode','bankBic','authUrl','refreshUrl','apiKey'].map(f =>
          <Form.Group key={f} className='mb-2'>
            <Form.Label>{f}</Form.Label>
            <Form.Control value={form[f]} onChange={e=>c(f,e.target.value)} />
          </Form.Group>
        )}
        <Form.Group>
          <Form.Label>Password / secret {initial && '(leave blank = unchanged)'}</Form.Label>
          <Form.Control type='password'
            value={form.apiSecret}
            onChange={e=>c('apiSecret',e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Cancel</Button>
        <Button variant='primary'  onClick={() => onSave(form)}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BankAuthModal;
